export const CARNET_MODULE_NAME = "carnet";
export const CARNET_PAYROLL_MODULE_NAME = "carnet-payroll";
